import {GridItem as ChakraGridItem, GridItemProps} from '@chakra-ui/react'

export const GridItem = (props: GridItemProps) => {
  return <ChakraGridItem {...props}></ChakraGridItem>
}
export default GridItem
